export default "__VITE_ASSET__CbHezPrf__"